import { render, staticRenderFns } from "./org_modal.vue?vue&type=template&id=5716bf00"
import script from "./org_modal.vue?vue&type=script&lang=js"
export * from "./org_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5716bf00')) {
      api.createRecord('5716bf00', component.options)
    } else {
      api.reload('5716bf00', component.options)
    }
    module.hot.accept("./org_modal.vue?vue&type=template&id=5716bf00", function () {
      api.rerender('5716bf00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/point_manage/point_rule/components/org_modal.vue"
export default component.exports